import { defineMessages } from "react-intl";
export const sources = [
    "salesOverview",
    "statusOverview",
    "financialVolumeOverview"
];
export const sourceMapTitles = defineMessages({
    salesOverview: {
        id: "dploy.grid.charts.source.option.salesOverview.label",
        defaultMessage: "Sales overview"
    },
    statusOverview: {
        id: "dploy.grid.charts.source.option.statusOverview.label",
        defaultMessage: "Status overview"
    },
    financialVolumeOverview: {
        id: "dploy.grid.charts.source.option.financialVolumeOverview.label",
        defaultMessage: "Financial volume overview"
    }
});
export function validChartData(chartData) {
    return chartData != null && chartData.series.some(s => s.points.length > 0);
}
//# sourceMappingURL=common.js.map